import UserChatClaims from './UserChatClaims';

export default UserChatClaims;
